import gql from 'graphql-tag'

export const AUTH_LOGIN = gql`
mutation(
    $mobile:String!
    $password:String!
  )
  {
    login(
      mobile:$mobile
      password:$password
    )
  }
`

export const AUTH_INFO = gql`
{
  authInfo{
	_id
	email
	permission
}
}
`